export default {"src":"/komodo/_next/static/media/footer-arrow.ea7f0f04.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};